import React from 'react'
import { Segment } from 'components/segment/Segment';
import SEO from 'components/seo';

export default () => (
    <>
        <SEO title="Feedback page" />
        <Segment>
            <div  style={{minHeight:'100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                This is feed back page..!
            </div>
        </Segment>
    </>
    )
